module.exports = "/fonts/vendor/@fortawesome/fontawesome-pro/webfa-duotone-900.svg?6607c2d6bd764e82a2662790d333c958";